
import Phoenix from "../app/containers/Bot/Phoenix"
import HomePage from "../app/containers/Home/HomePage"
import WhitelistPage from "../app/containers/whitelist/WhitelistPage"
import SubscriptionPage from "../app/containers/subscribe/SubscriptionPage"
import Raydium from "../app/containers/Raydium/Raydium"
import Dashboard from "../app/containers/Dashboard/Dashboard"
import SalePage from "../app/containers/SalePage/SalePage"
import AdminDashboard from "../app/containers/Dashboard/AdminDashboard"
import DashboardSidebar from "../app/containers/Dashboard/DashboardSidebar.jsx"
import DashboarClaim from "../app/containers/Dashboard/DashboardClaim.jsx"
import ReferralProgram from "../app/containers/Dashboard/components/ReferralProgram/ReferralProgram.jsx"
import Billing from "../app/containers/Dashboard/Billing.jsx"
import DashboardDocuments from "../app/containers/Dashboard/DashboardDocuments.jsx"


export const routingPages = [
    {
        component: HomePage,
        path: '/',
        children:false
    },
    // {
    //     component: Archangel,
    //     path: '/trade',
    //     children:false
    // },
    {
        component: WhitelistPage,
        path: '/whitelist',
        children:false
    },
    // {
    //     component: Raydium,
    //     path: '/raydium',
    //     children:false
    // },
    {
        component: SubscriptionPage,
        path: '/subscribe',
        children:false
    },
    // {
    //     component: Phoenix,
    //     path: '/pump',
    //     children:false
    // },
    {
        component: DashboardSidebar,
        path: '/dashboard',
        children:[
            {
                component: Dashboard,
                path: '',
                children:false
            },
            {
                component: SalePage,
                path: 'ico',
                children:false
            },
            {
                component: DashboarClaim,
                path: 'claim',
                children:false
            },
            {
                component: Phoenix,
                path: 'pumpbot',
                children:false
            },
            {
                component: Raydium,
                path: 'rayfast',
                children:false
            },
            {
                component: ReferralProgram,
                path: 'referrals',
                children:false
            },
            {
                component: Billing,
                path: 'billing',
                children:false
            },
            {
                component: DashboardDocuments,
                path: 'documents',
                children:false
            },
            // {
            //     component: HomePage,
            //     path: 'home',
            //     children:false
            // },
        ]
    },
    {
        component: SalePage,
        path: '/ico',
        children:false
    },

    {
        component: AdminDashboard,
        path: '/admin',
        children:false
    },
  
    // {
    //     component: DashboardLayout,
    //     path: 'dashboard',
    //     children:[
    //         {
    //         component: DashboardHome,
    //         path: '',
    //         children:false
    //          },
    //          {
    //             component: Launchpads,
    //             path: 'launchpads',
    //             children:false
    //         },
    //          {
    //             component: Chart,
    //             path: 'chart',
    //             children:false
    //         },
    //          {
    //             component: LaunchpadDetails,
    //             path: 'launchpads/:address',
    //             children:false
    //         },
    //          {
    //             component: RequestAudit,
    //             path: 'request-audit',
    //             children:false
    //         },
    //         {
    //         component: CreateHome,
    //         path:'create',
    //         children:[
    //             {
    //                 component: Create,
    //                 path: '',
    //                 children:false
    //                  }, 
    //             {
    //                 component: CreatePresale,
    //                 path: 'presale',
    //                 children:false
    //                  }, 
    //         ]
    //          },
    //         {
    //         component: MyContributions,
    //         path: 'contributions',
    //         children:false
    //          },
          
    //         {
    //         component: MyDapps,
    //         path: 'my-dapps',
    //         children:false
    //     },
    //         {
    //         component: MyTokens,
    //         path: 'my-tokens',
    //         children:false
    //     },
    //         {
    //         component: TokenDetails,
    //         path: 'my-tokens/:address',
    //         children:false
    //     },
    //         {
    //         component: MyLaunchpads,
    //         path: 'my-sales',
    //         children:false
    //     },
        
    //         {
    //         component: MyLocks,
    //         path: 'my-locks',
    //         children:false
    //     },
    //         {
    //         component: LockDetails,
    //         path: 'my-locks/:address',
    //         children:false
    //     },
    // ]

    // },
    
    // {
    //     component: ClaimReward,
    //     path: '/claim'
    // },
    // {
    //     component: Mint,
    //     path: '/mint'
    // },
    // {
    //     component: Mint,
    //     path: '/mint/:address'
    // },
    // {
    //     component: Gallery,
    //     path: '/gallery'
    // },
]

